import {
  PAYROLLCOMPONENT_LOADING,
  GET_PAYROLLCOMPONENT,
  GET_PAYROLLCOMPONENT_SUCCESS,
  GET_PAYROLLCOMPONENT_FAIL,
  ADD_PAYROLLCOMPONENT_SUCCESS,
  ADD_PAYROLLCOMPONENT_FAIL,
  DELETE_PAYROLLCOMPONENT_SUCCESS,
  DELETE_PAYROLLCOMPONENT_FAIL,
  UPDATE_PAYROLLCOMPONENT_SUCCESS,
  UPDATE_PAYROLLCOMPONENT_FAIL,
  PAYROLLCOMPONENT_RESET
} from "./actionType";

const INIT_STATE = {
  payrollComponents: [],
  error: {},
};

const PayrollComponent = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PAYROLLCOMPONENT_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PAYROLLCOMPONENT:
          return {
            ...state,
            payrollComponents: action.payload.data,
            isPayrollComponentCreated: false,
            isPayrollComponentSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PAYROLLCOMPONENT_FAIL:
      switch (action.payload.actionType) {
        case GET_PAYROLLCOMPONENT_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isPayrollComponentCreated: false,
            isPayrollComponentSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PAYROLLCOMPONENT: {
      return {
        ...state,
        isPayrollComponentCreated: false,
        loading: true,
      };
    }

    case PAYROLLCOMPONENT_LOADING: {
      return {
        ...state,
        isPayrollComponentCreated: false,
        loading: true,
      };
    }

    case ADD_PAYROLLCOMPONENT_SUCCESS:
      return {
        ...state,
        isPayrollComponentCreated: true,
        loading: false,
        payrollComponents: [action.payload.data, ...state.payrollComponents],
      };

    case ADD_PAYROLLCOMPONENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PAYROLLCOMPONENT_SUCCESS:
      return {
        ...state,
        loading: false,
        payrollComponents: state.payrollComponents.filter(
          payrollComponent => payrollComponent.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PAYROLLCOMPONENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PAYROLLCOMPONENT_SUCCESS:
      return {
        ...state,
        loading: false,
        payrollComponents: state.payrollComponents.map(payrollComponent =>
          payrollComponent.id.toString() === action.payload.data.id.toString() ? { ...payrollComponent, ...action.payload.data } : payrollComponent
        ),
      };

    case UPDATE_PAYROLLCOMPONENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PAYROLLCOMPONENT_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default PayrollComponent;